import { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import api from "../../api";
import calculatorImg from "../../images/calculator1.png";

export const ROICalculator = () => {
  const alert = useAlert();
  const [data, setData] = useState({
    investment: 100,
  });
  const [loader, setLoader] = useState(false);
  const [profitLoss, setProfitLoss] = useState(0);
  const [totalExit, setTotalExit] = useState(0);
  const [roiPercent, setRoiPercent] = useState(0);

  const onTextChange = (e, investmentVal) => {
    if (investmentVal) {
      setData({ ...data, investment: investmentVal });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  function formatPrice(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: value < 1 ? 4 : 2,
      maximumFractionDigits: value < 1 ? 8 : 2,
    }).format(value);
  }

  function calculateROI() {
    let investment = data?.investment;
    let buyPrice = data?.buyPrice;
    let sellPrice = data?.sellPrice;
    let investmentFee = data?.investFee || 0;
    let exitFee = data?.exitFee || 0;
    // Validate inputs
    if (!investment || !buyPrice || !sellPrice) {
      throw new Error("Investment, buy price, and sell price are required.");
    }

    // 1️⃣ Calculate number of units purchased (after investment fee)
    const netInvestment = investment - investmentFee;
    const units = netInvestment / buyPrice;

    // 2️⃣ Calculate total exit value (after exit fee)
    const grossExit = units * sellPrice;
    const totalExit = grossExit - exitFee;

    // 3️⃣ Calculate profit/loss
    const profitLoss = totalExit - investment;

    // 4️⃣ Calculate ROI percentage
    const roiPercent = (profitLoss / investment) * 100;

    setProfitLoss(parseFloat(profitLoss.toFixed(2)));
    setTotalExit(parseFloat(totalExit.toFixed(2)));
    setRoiPercent(parseFloat(roiPercent.toFixed(2)));
  }

  useEffect(() => {
    if (data?.investment && data?.buyPrice && data?.sellPrice) {
      calculateROI();
    }
  }, [data]);

  return (
    <div className="btcCalculatorSec">
      <h1 className="homeHeading text-center ">
        ROI / Profit–Loss <span>Calculator</span>
      </h1>
      <div className="cCard">
        <div className="cCardInner">
          <div className="row ai-center mb-4">
            <div className="col-md-6">
              <div className="contact-form signup-form">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Enter Investment</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="investment"
                        placeholder="$100"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.investment}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        data?.investment == 100
                          ? "selectBtn mb-4 active"
                          : "selectBtn mb-4"
                      }
                      onClick={(e) => onTextChange(e, 100)}
                    >
                      $100
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        data?.investment == 200
                          ? "selectBtn mb-4 active"
                          : "selectBtn mb-4"
                      }
                      onClick={(e) => onTextChange(e, 200)}
                    >
                      $200
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div
                      className={
                        data?.investment == 300
                          ? "selectBtn mb-4 active"
                          : "selectBtn mb-4"
                      }
                      onClick={(e) => onTextChange(e, 300)}
                    >
                      $300
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group">
                      <label>Buy Price</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="buyPrice"
                        placeholder="$0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.buyPrice}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label>Sell Price</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="sellPrice"
                        placeholder="$0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.sellPrice}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label>Investment Fee</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="investFee"
                        placeholder="$0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.investFee}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label>Exit Fee</label>
                      <input
                        onChange={(e) => onTextChange(e)}
                        type="number"
                        name="exitFee"
                        placeholder="$0"
                        className="form-control ng-dirty ng-invalid ng-touched"
                        value={data?.exitFee}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="imgDiv">
                <img src={calculatorImg} alt="calculator" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard  ">
                <div className="prCardInner">
                  <div className="title">Total Investment</div>
                  <div className="price">$ {data?.investment || 0} </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard ">
                <div className="prCardInner">
                  <div className="title">Profit/Loss</div>
                  <div className="price">$ {profitLoss || 0}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard  ">
                <div className="prCardInner">
                  <div className="title">Total Exit Amount</div>
                  <div className="price">$ {totalExit || 0}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-4">
              <div className="priceCard  ">
                <div className="prCardInner">
                  <div className="title">ROI</div>
                  <div className="price">{roiPercent || 0}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
